<template>
  <div v-if="errorOverlayState.isActive" class="error-overlay">
    <div class="error-overlay-container">
      <h1>{{ errorOverlayState.errorTitle }}</h1>
      <span>{{ errorOverlayState.errorMessage }}</span>
      <br />
      <div v-if="errorOverlayState.showNavigationButton" class="mt-2">
        <a
          :href="owlCoreRoute"
          :title="$t('navigateToStudyDetail')"
          class="link-underline-primary"
          data-test-id="btn-navigate-to-study-detail"
        >
          {{ $t('navigateToStudyDetail') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineOptions({ name: 'GlobalErrorOverlay' });

import { useGlobalErrorOverlay, useOwlCoreStudyUrl } from '@/common/utils';

const { errorOverlayState } = useGlobalErrorOverlay();
const owlCoreRoute = useOwlCoreStudyUrl();
</script>

<style src="./global-error-overlay.component.scss" scoped></style>
